/**
 * Provider factory. Resolves the active analytics sink(s) once and memoises
 * them. CleverTap has been fully removed — Wisetap is the only sink.
 */
import { WisetapProvider } from "./providers/WisetapProvider";
import type { AnalyticsProvider } from "./AnalyticsProvider";

let providers: AnalyticsProvider[] | null = null;

/** Active providers (lazy — no construction happens at import time). */
export const getProviders = (): AnalyticsProvider[] => {
  if (!providers) providers = [new WisetapProvider()];
  return providers;
};
